const validateFormConfirmationEmailField = ({ confirmationEmail = false, confirmationEmailField = null, fields = [] }) => {
  if (confirmationEmail && (!confirmationEmailField || !fields.find((f) => f._id === confirmationEmailField))) {
    return "Response confirmation will not work unless you select a 'confirmation email field'.";
  } else {
    return false;
  }
};

export default validateFormConfirmationEmailField;
